import React from 'react';
import BlogCard from './BlogCard';
import useScrollAnimation from '../../hooks/useScrollAnimation';

const BlogList = ({ posts }) => {
  // Scroll animation for grid
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation({ threshold: 0.05 });

  if (posts.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-text-primary font-body text-lg">
          No blog posts published yet. Check back soon!
        </p>
      </div>
    );
  }

  return (
    <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
      {posts.map((post, index) => (
        <div
          key={post._id}
          className={`transition-all duration-700 ease-out ${
            gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
          style={{
            transitionDelay: gridVisible ? `${index * 150}ms` : '0ms',
          }}
        >
          <BlogCard post={post} />
        </div>
      ))}
    </div>
  );
};

export default BlogList;
